<template>
  <div class="tab">
    <h1>Policies</h1>
    <div class="filter-container">
      <div class="flex">
        <div class="filter-box">
          <span class="label">Search</span>
          <div class="search-box">
            <v-input placeholder="Policy No., Customer Name, Insurer, Referrer or Price" />
          </div>
        </div>
        <div class="filter-box">
          <span class="label">Issue Date</span>
          <div class="search-box">
            <v-date-picker />
          </div>
        </div>
      </div>

      <div class="filter-box">
        <span class="label">
          Product Type
          <span class="all">Select All</span>
        </span>
        <v-checkbox-group :list="productTypeOptions"></v-checkbox-group>
      </div>
      <div class="filter-box">
        <span class="label">
          Status
          <span class="all">Select All</span>
        </span>
        <v-checkbox-group :list="statusOptions"></v-checkbox-group>
      </div>
    </div>
    <div class="transparent">
      <el-table
        :data="tableData"
        stripe
        style="width: 100%">
        <el-table-column
          prop="id"
          label="Issue Date & Time"></el-table-column>
        <el-table-column
          prop="id"
          label="ID"></el-table-column>
        <el-table-column
          prop="id"
          label="Product Type"></el-table-column>
        <el-table-column
          prop="id"
          label="Insurer"></el-table-column>
        <el-table-column
          prop="id"
          label="Policyholder"></el-table-column>
        <el-table-column
          prop="id"
          label="Contact Name"></el-table-column>
        <el-table-column
          prop="id"
          label="Phone No."></el-table-column>
        <el-table-column
          prop="id"
          label="Policy Period"></el-table-column>
        <el-table-column
          prop="id"
          label="Status"></el-table-column>
        <el-table-column
          prop="id"
          label="Tickets"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InsurerPpliciesTab',
  data() {
    return {
      productTypeOptions: [
        {
          name: 'Motor',
          id: 'Motor'
        },
        {
          name: 'Housemaid',
          id: 'Housemaid'
        },
        {
          name: 'Travel',
          id: 'Travel'
        },
        {
          name: 'Interior Decoration',
          id: 'Interior Decoration'
        },
        {
          name: 'Office',
          id: 'Office'
        },
        {
          name: 'Shop Package',
          id: 'Shop Package'
        }
      ],
      statusOptions: [
        {
          name: 'In Force',
          id: 'In Force'
        },
        {
          name: 'Expired',
          id: 'Expired'
        },
        {
          name: 'Cancelled',
          id: 'Cancelled'
        }
      ],
      tableData: [
        {
          id: '0'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.tab {
  position: relative;
  h1 {
    padding-bottom: 15px;
    color: #616266;
    font-size: 20px;
  }
  .top-right {
    position: absolute;
    top: 0;
    right: 0;
  }
  .filter-container {
    .filter-box {
      margin-bottom: 10px;
      .label {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;
        font-weight: bold;
        .all {
          display: inline-block;
          padding-left: 15px;
          color: #409eff;
          font-weight: 400;
          font-weight: 500;
        }
      }
      .search-box {
          margin-right: 20px;
        width: 400px;
      }
      .quote-box {
        width: 300px;
      }
    }
  }
}
</style>